import { useCallback } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { AuditLog } from "../../views/settings/AuditLog";
import { auditSearchSchema, type AuditSearch } from "../../views/settings/search";
import { SettingsPage } from "../../views/settings/SettingsLayout";
import { rootRoute } from "../root";

export const auditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/audit",
  validateSearch: auditSearchSchema,
  component: function AuditRoute() {
    const search = auditRoute.useSearch();
    const navigate = useNavigate({ from: "/settings/audit" });
    const onSearch = useCallback(
      (next: AuditSearch) => {
        void navigate({ search: next });
      },
      [navigate],
    );
    return <SettingsPage section="audit">{() => <AuditLog search={search} onSearch={onSearch} />}</SettingsPage>;
  },
});
